import { Empty, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getPayments } from "./service";
import { useSelector } from "react-redux";
import Moment from "react-moment";
import { convertUTCToLocalTime } from "../../utils/service";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import NumberFormat from "react-number-format";
import Loader from "../../shared/loader";
import AppAlert from "../../shared/appAlert";
import AppText from "../../shared/appText";
const { Title } = Typography;
const PaymentLinks = () => {
  const history = useHistory();
  const customerInfo = useSelector((store) => store.userConfig.userProfileInfo);
  const [reciverPayments, setReceiverPayments] = useState([]);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    getRecieverPayments();
  }, [])

  const getRecieverPayments = async () => {
    try {
      setLoader(true);
      let response = await getPayments('Merchant/recentpayments', customerInfo?.id);
      setReceiverPayments(response);
    }
    catch (errors) {
      setError(errors);
    }
    finally {
      setLoader(false);
    }
  }
  const handleRedirect = () => {
    history.push('/paymentlinks');
  };
  const redirectToPaymentLinks = (item) =>{
    history.push(`/paymentLinkView/${item?.id}/${item?.merchantName}`)
  }
  return (
    <div className="left-panel pannel-bg mb-leftpanel mb-0">
      
      <div className='custom-flex'>
        <Title className='card-title ordrhstry-title xs-fs-16'>Recent Payment Links</Title>
        <div onClick={handleRedirect}>
          <span className="text-link c-pointer view-more">View More</span> <span class="icon lg square-arrow c-pointer" ></span>
        </div></div>
        {loader ? <Loader /> : ""}
      {error && (
        <div className="alert-flex" style={{ width: "100%" }}>
          <AppAlert
            className="w-100 "
            type="warning"
            description={error}
            showIcon
          />
          <span className="icon sm alert-close" onClick={() => setError(null)}></span>
        </div>
      )}
      <div className="payment-links">
      {reciverPayments?.length === 0 && !loader && <div className="d-flex align-items-center h-full"> <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="No Data"
      ></Empty></div>}
      <table width={1150} className="recentpayments-table">
        {reciverPayments.length > 0 && reciverPayments.map((item, index) => (
          <tr key={index} className="custom-table card">
            <td className="" width={220}>
              <label className="table-label">Date</label>
              <Title level={4} className="table-text text-link c-pointer">
                <Moment format="DD/MM/YYYY hh:mm:ss A" onClick={()=>redirectToPaymentLinks(item)}>
                  {item?.date && convertUTCToLocalTime(item?.date)}
                </Moment>
              </Title>
            </td>
            <td className="" width={160}>
                <label className="table-label">Wallet Address</label>
                <Title level={4} className="table-text text-white">
                  {item?.walletAddress && <CopyToClipboard text={item?.walletAddress} options={{ format: 'text/plain' }}><AppText copyable={{ tooltips: ['Copy', 'Copied'] }} className="summary-text m-0">{item?.walletAddress.substring(0, 4)}...{item?.walletAddress.substring(item?.walletAddress.length - 4)}</AppText></CopyToClipboard>}
                </Title>
            
            </td>
            <td className="" width={130}>
              <label className="table-label">Value</label>
              <Title level={4} className="table-text">
                <NumberFormat value={item?.amount} displayType="text" thousandSeparator={true} />
              </Title>
            </td>
            <td className="">
              <label className="table-label">Coin</label>
              <Title level={4} className="table-text">
                <span className={`crypto coin sm ${item?.currency?.toLowerCase()}`}></span> {item?.currency}
              </Title>
            </td>
            <td className="">
              <label className="table-label">Network</label>
              <Title level={4} className="table-text">
                 {item?.network}
              </Title>
            </td>
            <td className="">
              <label className="table-label">Payment Type</label>
              <Title level={4} className="table-text">{item?.type}</Title>
            </td>
            <td className="">
              <label className="table-label">Status</label>
              <Title level={4} className={`table-text text-green ${item?.status == 'NotPaid' ? 'text-blue' : ''} ${item?.status == 'Not Paid' ? 'text-blue' : ''} ${item?.status == 'Paid' ? 'text-green' : ''} ${item.status == 'Failed' ? 'text-red' : ''}`}>{item.status}</Title>
            </td>
          </tr>
        ))}
        </table>
      </div>
    </div>
  )
}
export default PaymentLinks
